import { ACtaTextMixin } from '../utils/mixins/_a-cta-text';

class ACtaTextButton extends ACtaTextMixin(HTMLButtonElement) {}

customElements.define('a-cta-text-button', ACtaTextButton, { extends: 'button' });
